import React from "react";
import {
  CustomContactHistoryComponent,
  CustomMergingHistoryComponent,
  CustomPropertyHistoryComponent,
} from "../Sections/HistoryComponent";
import { useTranslate } from "../../../../Hooks";
import AgentWalletHistoryComponent from "../../../../Views/Home/AgentWalletConfigurationView/components/AgentWalletHistoryComponent";

const CustomHistoryComponentTabs = () => {
  const { translate: contactTranslate } = useTranslate("NewContactsView");
  const { translate: PropertyTranslate } = useTranslate("NewPropertiesView");

  const contactHistory = [
    {
      label: contactTranslate("history"),
      component: <CustomContactHistoryComponent />,
    },
    {
      label: contactTranslate("merging-history"),
      component: <CustomMergingHistoryComponent />,
    },
  ];
  const saleUnitHistory = [];
  const leaseUnitHistory = [];
  const unitPropertyManagmentHistory = [];
  const saleLeadsHistory = [];
  const leaseLeadHistory = [];
  const callCenterLeadHistory = [];
  const propertyManagmentLeadHistory = [];
   const propertyHistory = [
    {
      label: PropertyTranslate("history"),
      component: <CustomPropertyHistoryComponent />,
    },
  ];
  const propertyManagmentHistory = [];
  const LeadsMortgageHistory = [];
  const contactLeadHistory = [];
  const leadOwnerUnitSaleHistory = [];
  const leadOwnerUnitLeaseHistory = [];
  const leadOwnerLeadHistory = [];
  const rotationSchema = [];
  const manageAgents = [];
  const agentWalletHistory = [
    {
      label: "History",
      component: <AgentWalletHistoryComponent />, 
    },
  ];
  return {
    contactHistory,
    saleUnitHistory,
    leaseUnitHistory,
    unitPropertyManagmentHistory,
    saleLeadsHistory,
    leaseLeadHistory,
    callCenterLeadHistory,
    propertyManagmentLeadHistory,
    propertyHistory,
    propertyManagmentHistory,
    LeadsMortgageHistory,
    contactLeadHistory,
    leadOwnerUnitSaleHistory,
    leadOwnerUnitLeaseHistory,
    leadOwnerLeadHistory,
    rotationSchema,
    manageAgents,
    saleUnitHistory,
    agentWalletHistory
  };
};

export default CustomHistoryComponentTabs;
